import { Fragment } from "react";
import MaleIcon from '../../../../assets/icons/Man.svg';
import WomanIcon from '../../../../assets/icons/Woman.svg';

const AttendeeCard = ({ id, data, clickHandler }) => {
    const radius = 35;
    const circumference = 2 * Math.PI * radius;
    const dashLength = (circumference * data.mcqScore) / 100;
    const gapLength = circumference - dashLength;

    return (
        <Fragment>
            <div className="card border-0 shadow-sm p-3 h-100 cursor-pointer" onClick={() => clickHandler(id, data.attendeeName)}>
                <div className="d-flex bd-highlight">
                    <div>
                        <img
                            src={data.gender === 'M' ? MaleIcon : WomanIcon}
                            alt="User"
                            className="hover:opacity-70 ms-2 me-1"
                        />
                    </div>
                    <div className="p-2 mt-auto mb-auto">
                        <div className="title">{data.attendeeName}</div>
                        {data.isMCQExamCompleted && (<>
                            <div className="score-container pt-1">
                                <span style={{ color: '#2A96B8' }}>
                                    Original Score : {" "}
                                    <label className="score text-primary" style={{ color: '#000' }}>
                                        {data.correctMCQAnswers + data.graceMarks}/{data.totalMCQQuestions}
                                    </label>
                                </span>
                            </div>
                            {/* <div className="score-container pt-1">
                                <span>
                                    Percent : {" "}
                                    <label className="score">
                                        {data.mcqScore}%
                                    </label>
                                </span>
                            </div> */}
                        </>
                        )}
                    </div>

                    <div className="ms-auto">
                        <svg width="90" height="90" viewBox="0 0 90 90">
                            <circle cx="45" cy="45" r="45"
                                fill="#E3FEF3" />

                            <circle cx="45" cy="45" r="35"
                                fill="none"
                                stroke="#05A861"
                                strokeWidth="6"
                                strokeDasharray={`${dashLength} ${gapLength}`}
                                strokeLinecap="round"
                                transform="rotate(-90 45 45)"
                                className="progress-circle" />

                            <text x="45" y="50"
                                textAnchor="middle"
                                fontSize="16"
                                fontWeight="bold"
                                fill="#000">{data.mcqScore}%</text>
                        </svg>
                    </div>
                </div>
            </div>
        </Fragment >
    );
};

export default AttendeeCard;
